export const collectionDatalistLabel = item => `${item.house} — ${item.name}`

export function collectionDatalistItems(collection = [], userId) {
  if (!userId) return []
  return collection.filter(item => item.id && item.user_id === userId)
    .slice().sort((a, b) => collectionDatalistLabel(a).localeCompare(collectionDatalistLabel(b)))
}

// Native datalists return only text, never an option ID. Ambiguous labels must
// remain in the fallback results so the user can choose the exact owned row.
export function resolveCollectionDatalist(value, items = []) {
  const matches = items.filter(item => collectionDatalistLabel(item) === value)
  return matches.length === 1 ? matches[0] : null
}
